import React from 'react';
import Footer from './Footer';

function InfoPageShell({ children }) {
  return (
    <div className="relative min-h-[calc(100vh-8rem)]">
      <div
        className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(37,99,235,0.06)_0%,_transparent_50%)]"
        aria-hidden="true"
      />

      <div className="relative mx-2 md:mx-5 pb-12">
        {children}
      </div>

      <div className="relative mx-2 md:mx-5">
        <Footer />
      </div>
    </div>
  );
}

export default InfoPageShell;
